// Contenu de la page Mopper Business (/professionnels). FR = base, DE/EN traduits.
// Utilisé par ProfessionnelsIndex.jsx. Les icônes et slugs de liens sont gérés
// dans le composant (mapping par clé), pas ici.

export const BUSINESS_I18N = {
  fr: {
    seo: {
      title: "Mopper Business | Déménagement, débarras & services B2B",
      description:
        "Mopper accompagne les entreprises, régies, commerces et professionnels pour leurs propres besoins ou l'externalisation de prestations terrain : déménagement, débarras, transport, montage et nettoyage.",
    },
    hero: {
      badge: "Mopper Business",
      h1: "Mopper devient votre équipe terrain.",
      sub: "Déménagement, transport, débarras, montage, nettoyage et remise en ordre pour votre entreprise ou directement pour vos clients.",
      text: "Besoin ponctuel, prestations récurrentes ou service externalisé : Mopper prend en charge l'exécution opérationnelle avec un interlocuteur unique.",
      ctaPrimary: "Parler de votre besoin",
      ctaSecondary: "Externaliser une prestation",
      reassure: "Interventions ponctuelles · Missions récurrentes · Suisse romande · Un interlocuteur unique",
    },
    ways: {
      title: "Deux façons de travailler avec Mopper",
      cards: [
        {
          key: "company",
          title: "Pour votre entreprise",
          text: "Confiez à Mopper les opérations dont votre entreprise a directement besoin.",
          items: [
            "Déménagement de bureaux", "Transfert interne", "Débarras de locaux", "Désencombrement",
            "Transport de mobilier", "Montage et démontage", "Nettoyage après déménagement ou débarras",
            "Tri et évacuation", "Recyclage", "Remise en ordre d'espaces", "Interventions ponctuelles ou récurrentes",
          ],
          cta: "Découvrir les services entreprises",
        },
        {
          key: "clients",
          title: "Pour vos clients",
          text: "Vous vendez, gérez ou coordonnez un service ? Mopper peut prendre en charge son exécution terrain.",
          items: [
            "Livraison", "Transport", "Montage", "Collecte", "Débarras", "Déménagement",
            "Fin de bail", "Nettoyage", "Évacuation", "Reprise d'ancien mobilier", "Remise en ordre", "Désencombrement",
          ],
          cta: "Externaliser mes opérations",
        },
      ],
    },
    exec: {
      title: "Vous vendez le service. Nous exécutons le terrain.",
      text: "Votre entreprise reste l'interlocuteur de son client. Mopper peut intervenir sur le terrain pour réaliser tout ou partie de la prestation : transport, manutention, débarras, montage, nettoyage, déménagement ou remise en ordre.",
      models: [
        { t: "Mission ponctuelle", d: "Mopper prend en charge une intervention spécifique lorsque vous en avez besoin." },
        { t: "Prestataire récurrent", d: "Votre entreprise transmet régulièrement des missions à Mopper selon un processus défini." },
        { t: "Service intégré à votre offre", d: "Mopper devient la couche opérationnelle permettant à votre entreprise de proposer un service supplémentaire sans créer sa propre équipe terrain." },
      ],
    },
    sectors: {
      title: "Des solutions adaptées à votre activité",
      subtitle: "Des segments que Mopper peut servir, avec une exécution terrain sur mesure.",
      items: [
        { key: "regies", title: "Régies & gérances", cases: ["Logement après départ de locataire", "Débarras", "Nettoyage fin de bail", "Évacuation", "Déplacement de mobilier", "Remise en ordre", "Déménagement ponctuel"], cta: "Solutions pour les régies" },
        { key: "immobilier", title: "Agences immobilières & courtiers", cases: ["Préparer un logement avant vente", "Désencombrer", "Déplacer du mobilier", "Vider partiellement ou totalement", "Nettoyer", "Remettre en ordre"], cta: "Solutions immobilières" },
        { key: "meubles", title: "Magasins de meubles", cases: ["Livraison chez le client", "Manutention", "Montage", "Installation", "Démontage", "Reprise ou évacuation de l'ancien meuble si prévu"], cta: "Externaliser mes livraisons" },
        { key: "ecommerce", title: "E-commerce & seconde main", cases: ["Collecte chez vendeur", "Transport", "Livraison chez acheteur", "Manutention", "Montage", "Transport entre particuliers"], cta: "Créer une solution logistique" },
        { key: "architectes", title: "Architectes & décorateurs d'intérieur", cases: ["Transport de mobilier", "Déplacement de meubles", "Montage", "Démontage", "Évacuation de l'ancien mobilier", "Remise en place", "Organisation de l'espace"], cta: "Nous confier le terrain" },
        { key: "entreprises", title: "Entreprises & bureaux", cases: ["Déménagement de bureaux", "Transfert interne", "Déplacement de mobilier", "Débarras", "Réorganisation d'espace", "Démontage / remontage", "Nettoyage après intervention"], cta: "Organiser une intervention" },
        { key: "renovation", title: "Entreprises de rénovation", cases: ["Déplacement du mobilier avant travaux", "Évacuation d'éléments", "Transport", "Remise en place", "Nettoyage complémentaire", "Débarras lié à l'intervention"], cta: "Externaliser une opération" },
        { key: "ems", title: "EMS & structures d'accompagnement", cases: ["Déménagement", "Tri", "Désencombrement", "Réduction du volume d'affaires", "Transport vers proches ou nouveau logement", "Vidage d'appartement", "Nettoyage"], cta: "Parler d'un besoin" },
      ],
    },
    catalog: {
      title: "Une seule équipe pour plusieurs opérations terrain",
      subtitle: "Chaque prestation peut être combinée dans une même mission.",
      groups: [
        { key: "demenagement", title: "Déménagement", items: ["Bureaux", "Locaux", "Transferts internes", "Déménagements pour vos clients"] },
        { key: "debarras", title: "Débarras", items: ["Appartements", "Maisons", "Caves", "Bureaux", "Commerces", "Locaux professionnels"] },
        { key: "transport-de-meubles", title: "Transport", items: ["Mobilier", "Objets volumineux", "Matériel", "Achats clients", "Livraisons"] },
        { key: "montage-de-meubles", title: "Montage & démontage", items: ["Mobilier résidentiel", "Mobilier professionnel", "Remise en place"] },
        { key: "nettoyage", title: "Nettoyage", items: ["Après déménagement", "Après débarras", "Fin de bail", "Remise en état"] },
        { key: "desencombrement", title: "Désencombrement", items: ["Tri", "Réduction du volume", "Optimisation d'espace"] },
        { key: "recyclage", title: "Tri, évacuation & recyclage", items: ["Collecte", "Tri", "Déchèterie", "Revalorisation lorsque possible"] },
      ],
      cta: "Voir la prestation",
    },
    why: {
      title: "Pourquoi confier vos opérations terrain à Mopper ?",
      items: [
        { t: "Un seul prestataire", d: "Transport, montage, débarras, nettoyage et remise en ordre peuvent être regroupés." },
        { t: "Capacité flexible", d: "Absorbez des besoins ponctuels ou récurrents sans constituer immédiatement une équipe interne dédiée." },
        { t: "Une offre plus large pour vos clients", d: "Ajoutez une composante terrain à votre offre sans construire toute l'infrastructure opérationnelle." },
        { t: "Interlocuteur unique", d: "Une seule coordination, du premier contact à la fin de mission." },
        { t: "Multiservice", d: "Une seule mission peut combiner plusieurs prestations." },
        { t: "Suivi d'intervention", d: "Suivi, photos, informations d'intervention et validation quand la prestation le prévoit." },
      ],
    },
    examples: {
      title: "Concrètement, comment Mopper s'intègre à votre activité ?",
      note: "Ces scénarios illustrent notre fonctionnement. Ce ne sont pas des cas clients réels.",
      items: [
        { title: "Un magasin vend une armoire", steps: ["Le magasin transmet la mission.", "Mopper récupère le mobilier.", "Livraison chez le client.", "Montage sur place.", "Reprise de l'ancien meuble si prévue.", "Mission terminée."] },
        { title: "Une régie récupère un appartement", steps: ["Évaluation du besoin.", "Débarras du mobilier restant.", "Tri et évacuation.", "Nettoyage si demandé.", "Remise en ordre.", "Logement prêt pour l'étape suivante."] },
        { title: "Un architecte termine un projet", steps: ["Livraison ou déplacement du mobilier.", "Montage.", "Mise en place.", "Évacuation des emballages ou anciens éléments si prévu.", "Remise en ordre."] },
      ],
    },
    freq: {
      title: "Ponctuel ou récurrent ?",
      ponctuel: { t: "Besoin ponctuel", d: "Déménagement, débarras, livraison, intervention unique." },
      recurrent: { t: "Collaboration récurrente", d: "Missions régulières confiées par une régie, un magasin, une plateforme ou une entreprise." },
      cta: "Discuter d'une collaboration",
    },
    finalCta: {
      title: "Parlons de vos opérations terrain.",
      text: "Expliquez-nous votre besoin, votre volume de missions et les prestations à externaliser. Nous vous proposerons une organisation adaptée.",
      ctaPrimary: "Parler à Mopper Business",
      ctaSecondary: "Demander un devis",
    },
    labels: { cases: "Cas d'usage", useCasesArrow: "En savoir plus" },
  },

  de: {
    seo: {
      title: "Mopper Business | Umzug, Entrümpelung & B2B-Leistungen",
      description:
        "Mopper unterstützt Unternehmen, Verwaltungen, Geschäfte und Profis für ihre eigenen Bedürfnisse oder die Auslagerung von Einsätzen vor Ort: Umzug, Entrümpelung, Transport, Montage und Reinigung.",
    },
    hero: {
      badge: "Mopper Business",
      h1: "Mopper wird zu Ihrem Team vor Ort.",
      sub: "Umzug, Transport, Entrümpelung, Montage, Reinigung und Instandstellung für Ihr Unternehmen oder direkt für Ihre Kunden.",
      text: "Einmaliger Bedarf, wiederkehrende Leistungen oder ausgelagerter Service: Mopper übernimmt die operative Ausführung mit einem einzigen Ansprechpartner.",
      ctaPrimary: "Über Ihren Bedarf sprechen",
      ctaSecondary: "Eine Leistung auslagern",
      reassure: "Einmalige Einsätze · Wiederkehrende Aufträge · Westschweiz · Ein Ansprechpartner",
    },
    ways: {
      title: "Zwei Arten, mit Mopper zu arbeiten",
      cards: [
        {
          key: "company",
          title: "Für Ihr Unternehmen",
          text: "Übergeben Sie Mopper die Einsätze, die Ihr Unternehmen direkt benötigt.",
          items: [
            "Büroumzug", "Interne Verlegung", "Räumung von Lokalen", "Ausräumen",
            "Möbeltransport", "Montage und Demontage", "Reinigung nach Umzug oder Entrümpelung",
            "Sortieren und Entsorgen", "Recycling", "Instandstellung von Räumen", "Einmalige oder wiederkehrende Einsätze",
          ],
          cta: "Leistungen für Unternehmen entdecken",
        },
        {
          key: "clients",
          title: "Für Ihre Kunden",
          text: "Sie verkaufen, verwalten oder koordinieren eine Leistung? Mopper übernimmt die Ausführung vor Ort.",
          items: [
            "Lieferung", "Transport", "Montage", "Abholung", "Entrümpelung", "Umzug",
            "Wohnungsübergabe", "Reinigung", "Entsorgung", "Rücknahme alter Möbel", "Instandstellung", "Ausräumen",
          ],
          cta: "Meine Einsätze auslagern",
        },
      ],
    },
    exec: {
      title: "Sie verkaufen die Leistung. Wir führen sie vor Ort aus.",
      text: "Ihr Unternehmen bleibt der Ansprechpartner seines Kunden. Mopper kann vor Ort einen Teil oder die gesamte Leistung übernehmen: Transport, Handling, Entrümpelung, Montage, Reinigung, Umzug oder Instandstellung.",
      models: [
        { t: "Einmaliger Einsatz", d: "Mopper übernimmt einen spezifischen Einsatz, wenn Sie ihn benötigen." },
        { t: "Wiederkehrender Dienstleister", d: "Ihr Unternehmen übergibt Mopper regelmässig Aufträge nach einem definierten Prozess." },
        { t: "In Ihr Angebot integrierter Service", d: "Mopper wird zur operativen Ebene, mit der Ihr Unternehmen eine zusätzliche Leistung anbieten kann, ohne ein eigenes Team vor Ort aufzubauen." },
      ],
    },
    sectors: {
      title: "Passende Lösungen für Ihre Tätigkeit",
      subtitle: "Segmente, die Mopper bedienen kann, mit massgeschneiderter Ausführung vor Ort.",
      items: [
        { key: "regies", title: "Verwaltungen & Hausverwaltungen", cases: ["Wohnung nach Auszug", "Entrümpelung", "Endreinigung", "Entsorgung", "Möbel verschieben", "Instandstellung", "Einmaliger Umzug"], cta: "Lösungen für Verwaltungen" },
        { key: "immobilier", title: "Immobilienagenturen & Makler", cases: ["Wohnung vor Verkauf vorbereiten", "Ausräumen", "Möbel verschieben", "Teilweise oder vollständig leeren", "Reinigen", "Instandstellen"], cta: "Immobilienlösungen" },
        { key: "meubles", title: "Möbelgeschäfte", cases: ["Lieferung zum Kunden", "Handling", "Montage", "Installation", "Demontage", "Rücknahme oder Entsorgung des alten Möbels falls vorgesehen"], cta: "Meine Lieferungen auslagern" },
        { key: "ecommerce", title: "E-Commerce & Secondhand", cases: ["Abholung beim Verkäufer", "Transport", "Lieferung zum Käufer", "Handling", "Montage", "Transport zwischen Privatpersonen"], cta: "Eine Logistiklösung schaffen" },
        { key: "architectes", title: "Architekten & Innenausstatter", cases: ["Möbeltransport", "Möbel verschieben", "Montage", "Demontage", "Entsorgung alter Möbel", "Wiederaufstellung", "Raumorganisation"], cta: "Uns die Ausführung anvertrauen" },
        { key: "entreprises", title: "Unternehmen & Büros", cases: ["Büroumzug", "Interne Verlegung", "Möbel verschieben", "Entrümpelung", "Raumumgestaltung", "Demontage / Montage", "Reinigung nach Einsatz"], cta: "Einen Einsatz organisieren" },
        { key: "renovation", title: "Renovationsunternehmen", cases: ["Möbel vor Arbeiten verschieben", "Elemente entsorgen", "Transport", "Wiederaufstellung", "Ergänzende Reinigung", "Entrümpelung im Zusammenhang mit dem Einsatz"], cta: "Einen Einsatz auslagern" },
        { key: "ems", title: "Pflegeheime & Begleitstrukturen", cases: ["Umzug", "Sortieren", "Ausräumen", "Reduktion des Hausrats", "Transport zu Angehörigen oder in die neue Wohnung", "Wohnung leeren", "Reinigung"], cta: "Über einen Bedarf sprechen" },
      ],
    },
    catalog: {
      title: "Ein Team für mehrere Einsätze vor Ort",
      subtitle: "Jede Leistung kann in einem einzigen Einsatz kombiniert werden.",
      groups: [
        { key: "demenagement", title: "Umzug", items: ["Büros", "Lokale", "Interne Verlegungen", "Umzüge für Ihre Kunden"] },
        { key: "debarras", title: "Entrümpelung", items: ["Wohnungen", "Häuser", "Keller", "Büros", "Geschäfte", "Geschäftsräume"] },
        { key: "transport-de-meubles", title: "Transport", items: ["Mobiliar", "Sperrige Gegenstände", "Material", "Kundeneinkäufe", "Lieferungen"] },
        { key: "montage-de-meubles", title: "Montage & Demontage", items: ["Wohnmobiliar", "Büromobiliar", "Wiederaufstellung"] },
        { key: "nettoyage", title: "Reinigung", items: ["Nach Umzug", "Nach Entrümpelung", "Wohnungsübergabe", "Instandstellung"] },
        { key: "desencombrement", title: "Ausräumen", items: ["Sortieren", "Volumen reduzieren", "Raumoptimierung"] },
        { key: "recyclage", title: "Sortieren, Entsorgen & Recycling", items: ["Abholung", "Sortieren", "Deponie", "Wiederverwertung wenn möglich"] },
      ],
      cta: "Leistung ansehen",
    },
    why: {
      title: "Warum Ihre Einsätze vor Ort Mopper anvertrauen?",
      items: [
        { t: "Ein einziger Dienstleister", d: "Transport, Montage, Entrümpelung, Reinigung und Instandstellung können gebündelt werden." },
        { t: "Flexible Kapazität", d: "Decken Sie einmaligen oder wiederkehrenden Bedarf ab, ohne sofort ein eigenes Team aufzubauen." },
        { t: "Ein grösseres Angebot für Ihre Kunden", d: "Ergänzen Sie Ihr Angebot um eine Komponente vor Ort, ohne die ganze Infrastruktur aufzubauen." },
        { t: "Ein Ansprechpartner", d: "Eine einzige Koordination, vom ersten Kontakt bis zum Ende des Einsatzes." },
        { t: "Multiservice", d: "Ein einziger Einsatz kann mehrere Leistungen kombinieren." },
        { t: "Einsatz-Nachverfolgung", d: "Nachverfolgung, Fotos, Einsatzinformationen und Validierung, wenn die Leistung dies vorsieht." },
      ],
    },
    examples: {
      title: "Konkret: Wie integriert sich Mopper in Ihre Tätigkeit?",
      note: "Diese Szenarien veranschaulichen unsere Arbeitsweise. Es sind keine realen Kundenfälle.",
      items: [
        { title: "Ein Geschäft verkauft einen Schrank", steps: ["Das Geschäft übergibt den Auftrag.", "Mopper holt das Möbel ab.", "Lieferung zum Kunden.", "Montage vor Ort.", "Rücknahme des alten Möbels falls vorgesehen.", "Auftrag erledigt."] },
        { title: "Eine Verwaltung übernimmt eine Wohnung", steps: ["Bedarfsabklärung.", "Entrümpelung des verbliebenen Mobiliars.", "Sortieren und Entsorgen.", "Reinigung auf Wunsch.", "Instandstellung.", "Wohnung bereit für den nächsten Schritt."] },
        { title: "Ein Architekt schliesst ein Projekt ab", steps: ["Lieferung oder Verschieben des Mobiliars.", "Montage.", "Aufstellung.", "Entsorgung von Verpackungen oder alten Elementen falls vorgesehen.", "Instandstellung."] },
      ],
    },
    freq: {
      title: "Einmalig oder wiederkehrend?",
      ponctuel: { t: "Einmaliger Bedarf", d: "Umzug, Entrümpelung, Lieferung, einmaliger Einsatz." },
      recurrent: { t: "Wiederkehrende Zusammenarbeit", d: "Regelmässige Aufträge von einer Verwaltung, einem Geschäft, einer Plattform oder einem Unternehmen." },
      cta: "Über eine Zusammenarbeit sprechen",
    },
    finalCta: {
      title: "Sprechen wir über Ihre Einsätze vor Ort.",
      text: "Beschreiben Sie uns Ihren Bedarf, Ihr Auftragsvolumen und die auszulagernden Leistungen. Wir schlagen Ihnen eine passende Organisation vor.",
      ctaPrimary: "Mit Mopper Business sprechen",
      ctaSecondary: "Angebot anfragen",
    },
    labels: { cases: "Anwendungsfälle", useCasesArrow: "Mehr erfahren" },
  },

  en: {
    seo: {
      title: "Mopper Business | Removals, clear-out & B2B services",
      description:
        "Mopper supports companies, property managers, shops and professionals for their own needs or to outsource field services: removals, clear-out, transport, assembly and cleaning.",
    },
    hero: {
      badge: "Mopper Business",
      h1: "Mopper becomes your field team.",
      sub: "Removals, transport, clear-out, assembly, cleaning and reset for your company or directly for your clients.",
      text: "One-off need, recurring services or outsourced service: Mopper handles the operational execution with a single point of contact.",
      ctaPrimary: "Discuss your needs",
      ctaSecondary: "Outsource a service",
      reassure: "One-off jobs · Recurring missions · French-speaking Switzerland · A single point of contact",
    },
    ways: {
      title: "Two ways to work with Mopper",
      cards: [
        {
          key: "company",
          title: "For your company",
          text: "Entrust Mopper with the operations your company directly needs.",
          items: [
            "Office removals", "Internal transfer", "Premises clear-out", "Decluttering",
            "Furniture transport", "Assembly and dismantling", "Cleaning after removals or clear-out",
            "Sorting and disposal", "Recycling", "Space reset", "One-off or recurring work",
          ],
          cta: "Explore business services",
        },
        {
          key: "clients",
          title: "For your clients",
          text: "You sell, manage or coordinate a service? Mopper can handle its field execution.",
          items: [
            "Delivery", "Transport", "Assembly", "Collection", "Clear-out", "Removals",
            "End of lease", "Cleaning", "Disposal", "Old furniture take-back", "Reset", "Decluttering",
          ],
          cta: "Outsource my operations",
        },
      ],
    },
    exec: {
      title: "You sell the service. We execute in the field.",
      text: "Your company remains its client's point of contact. Mopper can step in on the field to carry out all or part of the service: transport, handling, clear-out, assembly, cleaning, removals or reset.",
      models: [
        { t: "One-off mission", d: "Mopper handles a specific job whenever you need it." },
        { t: "Recurring provider", d: "Your company regularly passes missions to Mopper following a defined process." },
        { t: "Service integrated into your offer", d: "Mopper becomes the operational layer that lets your company offer an extra service without building its own field team." },
      ],
    },
    sectors: {
      title: "Solutions tailored to your business",
      subtitle: "Segments Mopper can serve, with tailored field execution.",
      items: [
        { key: "regies", title: "Property managers & lettings", cases: ["Flat after a tenant leaves", "Clear-out", "End-of-lease cleaning", "Disposal", "Moving furniture", "Reset", "One-off move"], cta: "Solutions for property managers" },
        { key: "immobilier", title: "Estate agencies & brokers", cases: ["Prepare a home before sale", "Declutter", "Move furniture", "Empty partially or fully", "Clean", "Reset"], cta: "Real estate solutions" },
        { key: "meubles", title: "Furniture stores", cases: ["Delivery to the customer", "Handling", "Assembly", "Installation", "Dismantling", "Take-back or disposal of the old item if planned"], cta: "Outsource my deliveries" },
        { key: "ecommerce", title: "E-commerce & second-hand", cases: ["Collection at the seller", "Transport", "Delivery to the buyer", "Handling", "Assembly", "Transport between individuals"], cta: "Build a logistics solution" },
        { key: "architectes", title: "Architects & interior designers", cases: ["Furniture transport", "Moving furniture", "Assembly", "Dismantling", "Old furniture disposal", "Reinstallation", "Space organisation"], cta: "Entrust us with the field" },
        { key: "entreprises", title: "Companies & offices", cases: ["Office removals", "Internal transfer", "Moving furniture", "Clear-out", "Space reorganisation", "Dismantling / reassembly", "Cleaning after the job"], cta: "Organise a job" },
        { key: "renovation", title: "Renovation companies", cases: ["Move furniture before works", "Remove elements", "Transport", "Reinstallation", "Additional cleaning", "Clear-out linked to the job"], cta: "Outsource an operation" },
        { key: "ems", title: "Care homes & support structures", cases: ["Removals", "Sorting", "Decluttering", "Reducing belongings", "Transport to relatives or a new home", "Emptying a flat", "Cleaning"], cta: "Discuss a need" },
      ],
    },
    catalog: {
      title: "One team for several field operations",
      subtitle: "Every service can be combined within a single mission.",
      groups: [
        { key: "demenagement", title: "Removals", items: ["Offices", "Premises", "Internal transfers", "Removals for your clients"] },
        { key: "debarras", title: "Clear-out", items: ["Flats", "Houses", "Cellars", "Offices", "Shops", "Business premises"] },
        { key: "transport-de-meubles", title: "Transport", items: ["Furniture", "Bulky items", "Equipment", "Client purchases", "Deliveries"] },
        { key: "montage-de-meubles", title: "Assembly & dismantling", items: ["Residential furniture", "Professional furniture", "Reinstallation"] },
        { key: "nettoyage", title: "Cleaning", items: ["After removals", "After clear-out", "End of lease", "Reset to condition"] },
        { key: "desencombrement", title: "Decluttering", items: ["Sorting", "Volume reduction", "Space optimisation"] },
        { key: "recyclage", title: "Sorting, disposal & recycling", items: ["Collection", "Sorting", "Recycling centre", "Recovery when possible"] },
      ],
      cta: "View the service",
    },
    why: {
      title: "Why entrust your field operations to Mopper?",
      items: [
        { t: "A single provider", d: "Transport, assembly, clear-out, cleaning and reset can be bundled together." },
        { t: "Flexible capacity", d: "Absorb one-off or recurring needs without immediately building a dedicated in-house team." },
        { t: "A broader offer for your clients", d: "Add a field component to your offer without building the whole operational infrastructure." },
        { t: "A single point of contact", d: "One coordination, from first contact to the end of the mission." },
        { t: "Multi-service", d: "A single mission can combine several services." },
        { t: "Job tracking", d: "Tracking, photos, job information and validation when the service provides for it." },
      ],
    },
    examples: {
      title: "In practice, how does Mopper fit into your business?",
      note: "These scenarios illustrate how we work. They are not real client cases.",
      items: [
        { title: "A store sells a wardrobe", steps: ["The store passes the mission.", "Mopper picks up the furniture.", "Delivery to the customer.", "On-site assembly.", "Take-back of the old item if planned.", "Mission complete."] },
        { title: "A property manager takes back a flat", steps: ["Needs assessment.", "Clear-out of remaining furniture.", "Sorting and disposal.", "Cleaning if requested.", "Reset.", "Flat ready for the next step."] },
        { title: "An architect finishes a project", steps: ["Delivery or moving of furniture.", "Assembly.", "Placement.", "Disposal of packaging or old items if planned.", "Reset."] },
      ],
    },
    freq: {
      title: "One-off or recurring?",
      ponctuel: { t: "One-off need", d: "Removals, clear-out, delivery, a single job." },
      recurrent: { t: "Recurring collaboration", d: "Regular missions entrusted by a property manager, a store, a platform or a company." },
      cta: "Discuss a collaboration",
    },
    finalCta: {
      title: "Let's talk about your field operations.",
      text: "Tell us about your needs, your mission volume and the services to outsource. We'll propose a suitable setup.",
      ctaPrimary: "Talk to Mopper Business",
      ctaSecondary: "Request a quote",
    },
    labels: { cases: "Use cases", useCasesArrow: "Learn more" },
  },
};

// Lien de destination par secteur (page segment existante ou devis pro pré-rempli).
export const SECTOR_LINKS = {
  regies: "/professionnels/regies-immobilieres",
  immobilier: "/professionnels/regies-immobilieres",
  meubles: "/devis?type=pro&service=transport",
  ecommerce: "/devis?type=pro&service=transport",
  architectes: "/devis?type=pro&service=transport",
  entreprises: "/professionnels/demenagement-bureaux",
  renovation: "/devis?type=pro&service=demenagement",
  ems: "/devis?type=pro&service=demenagement",
};
